import Train from './Train';
import NoTrainResults from './NoTrainResults';
import React from 'react';
import { getStations, getTrains, findRoute, findRouteFrom, findRouteTo, findTrain } from '../finder.js';
import { timeDiff, normalizeMulti, normalize, cleanStationNameForInfofer, isTimeBeforeNow } from '../utils.js';
import { t, currentLanguage, switchLanguage } from '../lang/trans.js';
import { Layout, Header, Navigation, Content } from 'react-mdl/lib/Layout';
import Button from 'react-mdl/lib/Button';
import { Tabs, Tab } from 'react-mdl/lib/Tabs';
import { Card } from 'react-mdl/lib/Card';
import AutoComplete from './AutoComplete';
import Icon from 'react-mdl/lib/Icon';
import Switch from 'react-mdl/lib/Switch';
import FABButton from 'react-mdl/lib/FABButton';
import Spinner from 'react-mdl/lib/Spinner';
import firebase from 'firebase';

const firebaseConfig = {
  apiKey: 'AIzaSyD3nyYOe5GEaEkrobRx5zO9Wugl3auC9MA',
  authDomain: 'intarzieriacceleratul.firebaseapp.com',
  databaseURL: 'https://intarzieriacceleratul.firebaseio.com',
  storageBucket: 'intarzieriacceleratul.appspot.com'
};

let firebaseApp;
if(!firebase.apps.length) {
  firebaseApp = firebase.initializeApp(firebaseConfig).database();
} else {
  firebaseApp = firebase.apps[0].database();
}


export default class Page extends React.Component {
  constructor(props) {
    super(props);
    const stations = getStations();
    const trains = getTrains();
    this.state = {
      stations,
      trains,
      directOnly: false
    };
  }

  selectedTab() {
    return this.props.location.pathname.indexOf('train') !== -1 ? 'train' : 'route';
  }

  selectedTabId() {
    return ['route', 'train'].indexOf(this.selectedTab())
  }

  fakeSearch() {
    this.setState({ loading: true });
    setTimeout(() => {
      this.setState({ loading: false });
    }, 200);
  }

  updateFrom(station) {
    this.setState({ loading: true });

    setTimeout(() => {
      this.setState({ loading: false });
      if(!this.props.params.routeTo) {
        this.context.router.replace(`/route/${station}/`);
      } else {
        this.context.router.replace(`/route/${station}/${this.props.params.routeTo}/`);
      }
    }, 200);
  }

  updateTo(station) {
    this.setState({ loading: true });

    setTimeout(() => {
      this.setState({ loading: false });
      this.context.router.replace(`/route/${this.props.params.routeFrom || ''}/${station}/`);
    }, 200);
  }

  updateTrain(train) {
    this.setState({ loading: true });

    setTimeout(() => {
      this.setState({ loading: false });
      this.context.router.replace(`/train/${train}/`);
    });
  }

  autoCompleteFilter(searchText, key) {
    return normalizeMulti(key).filter(
      option => option.indexOf(normalize(searchText)) !== -1
    ).length > 0;
  }

  reverseStations() {
    this.setState({ loading: true });

    setTimeout(() => {
      this.setState({ loading: false });
      this.context.router.replace(`/route/${this.props.params.routeTo}/${this.props.params.routeFrom}/`);
    }, 200);
  }

  changeTab(selectedTabId) {
    this.context.router.replace(
      selectedTabId === 0 ? '/route/' : '/train/'
    );
  }

  setDirectOnly() {
    this.setState({ directOnly: !this.state.directOnly });
  }

  searchOnInfofer() {
    const date = new Date();
    const today = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;

    const leavesFrom = cleanStationNameForInfofer(this.props.params.routeFrom);
    const arrivesAt = cleanStationNameForInfofer(this.props.params.routeTo);
    const lang = 'en';
    window.location = `https://bilete.cfrcalatori.ro/vanzare/rute_.aspx?keyimt=dtm%3d${today}&p=${leavesFrom}&d=${arrivesAt}&ora=CURENTA&cautavans=0&lng=${lang}`;
  }

  render() {
    let trains;
    let fastestTrain;
    if(this.selectedTab() === 'route') {
      if(this.props.params.routeFrom === this.props.params.routeTo) {
        trains = [];
      } else if(this.props.params.routeFrom && !this.props.params.routeTo) {
        trains = findRouteFrom(this.props.params.routeFrom);
      } else if(!this.props.params.routeFrom && this.props.params.routeTo) {
        trains = findRouteTo(this.props.params.routeTo);
      } else {
        trains = findRoute(this.props.params.routeFrom, this.props.params.routeTo);
        if(trains.length > 1) {
          fastestTrain = trains[0];
          trains.slice(1).map(train => {
            if(timeDiff(train.leavesAt, train.arrivesAt) < timeDiff(fastestTrain.leavesAt, fastestTrain.arrivesAt)) {
              fastestTrain = train;
            }
          });
        }
      }
      if(this.state.directOnly) {
        trains = trains.filter(train => train.legs.length === 1);
      }
    } else {
      trains = findTrain(this.props.params.trainNumber);
    }

    const otherLanguage = currentLanguage() === 'ro' ? 'EN' : 'RO';

    const renderTrain = (train, idx) => {
      const firstTrain = train.legs[0].train;
      const fullTrainNumber = `${firstTrain.type} ${firstTrain.number}`;
      return <Train
        firebase={firebaseApp}
        train={train}
        forceOpen={this.selectedTab() === 'train' && fullTrainNumber === this.props.params.trainNumber}
        key={`${idx} ${train.legs.map(leg => leg.train.number).join(' ')}`}
        isFastest={train === fastestTrain}
        showStations={this.selectedTab() === 'train' || !this.props.params.routeFrom || !this.props.params.routeTo}
      />;
    }

    const trainsBefore = trains.filter(train => isTimeBeforeNow(train.leavesAt));
    const trainsAfter = trains.filter(train => !isTimeBeforeNow(train.leavesAt));

    return (
      <div>
        <Layout fixedHeader>
          <Header title={
            <img src="/images/header-logo.png" height="64" width="195" />
          }>
            <Navigation>
              <a href="mailto:gabi@purcaru.com">
                BETA
              </a>
            </Navigation>
          </Header>

          <Content className="Page-content">
          <Card shadow={0} style={{ width: '100%', marginBottom: '10px', padding: '10px' }}>
            <Tabs ripple activeTab={this.selectedTabId()} onChange={this.changeTab.bind(this)} style={{ marginBottom: '10px' }} className='Tabs-full-width is-upgraded'>
              <Tab>{t('search route')}</Tab>
              <Tab>{t('search train')}</Tab>
            </Tabs>

            {this.selectedTab() !== 'route' ? null :
              <div>
                <div style={{ position: 'relative' }}>
                  <AutoComplete
                    hintText={t('from')}
                    fullWidth={true}
                    maxSearchResults={6}
                    searchText={this.props.params.routeFrom}
                    onNewRequest={this.updateFrom.bind(this)}
                    filter={this.autoCompleteFilter}
                    dataSource={this.state.stations}
                    id='routeFrom'
                  />
                </div>
                <div style={{ position: 'relative' }}>
                  <AutoComplete
                    hintText={t('to')}
                    fullWidth={true}
                    maxSearchResults={6}
                    searchText={this.props.params.routeTo}
                    onNewRequest={this.updateTo.bind(this)}
                    filter={this.autoCompleteFilter}
                    dataSource={this.state.stations}
                    id='routeTo'
                  />
                </div>

                <div>
                  <Button
                    raised
                    colored
                    style={{ marginRight: '10px' }}
                    onClick={this.fakeSearch.bind(this)}
                  >
                    <Icon name="search" />
                    {t('search')}
                  </Button>
                  <Button
                    raised
                    onClick={this.reverseStations.bind(this)}
                  >
                    <Icon name="compare_arrows" />
                    {t('reverse')}
                  </Button>
                  {this.props.params.routeFrom && this.props.params.routeTo ?
                    <div style={{ marginTop: '10px' }}>
                      <Button
                        accent
                        raised
                        onClick={this.searchOnInfofer.bind(this)}
                      >
                        <Icon name="train" />
                        {t('search on infofer')}
                      </Button>
                    </div>
                  : null}
                  <div style={{ marginTop: '10px' }}></div>
                  <Switch
                    checked={this.state.directOnly}
                    onChange={this.setDirectOnly.bind(this)}
                    ripple
                  >
                    {t('only direct routes')}
                  </Switch>
                </div>
              </div>
            }

            {this.selectedTab() !== 'train' ? null :
              <div>
                <AutoComplete
                  hintText={t('train number')}
                  fullWidth={true}
                  maxSearchResults={10}
                  searchText={this.props.params.trainNumber}
                  onNewRequest={this.updateTrain.bind(this)}
                  filter={this.autoCompleteFilter}
                  dataSource={this.state.trains} />
                <Button raised colored onClick={this.fakeSearch.bind(this)}>
                  <Icon name="search"/>
                  {t('search')}
                </Button>
              </div>
            }
            </Card>

            {this.state.loading ?
              <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <Spinner />
              </div>
            :
              <div>
                {trainsBefore.map(renderTrain)}
                {trainsBefore.length && trainsAfter.length ? <hr/> : null}
                {trainsAfter.map(renderTrain)}
              </div>
            }

            {trains.length === 0 ?
              <NoTrainResults />
            : ''}

            <Card className="footer">
              <p dangerouslySetInnerHTML={{ __html: t('footer disclaimer') }}>
              </p>
              <p>
                {t('footer contact')} <a href="mailto:gabi+acceleratul@purcaru.com">gabi@purcaru.com</a>.
              </p>
              <p>
                &copy;2016 <a href="http://gabi.purcaru.com">Gabi Purcaru</a>
              </p>
              <p>
                <a href="https://www.facebook.com/acceleratul">
                  <img src="/images/fb-logo-small.png" width="29" height="29" />
                </a>
              </p>
            </Card>
          </Content>
        </Layout>

        <FABButton
          style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: '10' }}
          raised
          primary
          mini
          href='tel:+40219521'
        >
          <Icon name="call" />
        </FABButton>

        <FABButton
          style={{ position: 'fixed', bottom: '65px', right: '20px', zIndex: '10' }}
          primary
          raised
          mini
          onMouseUp={switchLanguage}
        >
          <strong style={{ color: 'white' }}><small>{otherLanguage}</small></strong>
        </FABButton>
      </div>
    );
  }
}

Page.contextTypes = {
  router: React.PropTypes.object.isRequired
};



/** WEBPACK FOOTER **
 ** ./src/components/Page.js
 **/